export default "__VITE_ASSET__c7b89f66__"